import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
const ExchangeRefundContentWrapper = ({ className, classes, width = 'xl', icon, title, controls, children }) => {
    const { ExchangeRefundContentWrapper: theme } = useTheme('Entities').Order;
    return (React.createElement("div", { className: cn(theme.root, className, classes === null || classes === void 0 ? void 0 : classes.root, {
            [theme.root_small]: width === 'sm'
        }) },
        React.createElement("div", { className: cn(theme.header, classes === null || classes === void 0 ? void 0 : classes.header) },
            React.createElement("div", { className: theme.title },
                React.createElement("div", { className: theme.icon }, icon),
                title),
            controls && React.createElement("div", { className: theme.controls }, controls)),
        children));
};
export default ExchangeRefundContentWrapper;
